export default __webpack_public_path__ + "static/FAM1170J72H-8a018cac3534f7b811d0bbea769ba43a.jpg";